import { getStatusVisualProps, getStatusOnlineId } from '@/utils/baseStationsUtils';

const addBaselineStatusData = item => ({
	...item,
	key: item.id,
	statusData: getStatusVisualProps(getStatusOnlineId(item)),
});

export { addBaselineStatusData };
